/**
 * 2019-04-11
 * handan
 * 核实结果页
 */

import React, { Component } from 'react'
import "./style.scss";

import { connect } from "react-redux";

import ResultHide from "./ResultHide";
import ResultShow from "./ResultShow";
import ResultError from "./ResultError";
import ToPay from "./Topay";
import getQueryString from "../../utils/getQueryString";
import { ModalPop, } from "../../components";
import { getPayResult } from "../../models";

import { getVerifyResultData, getUserName, getPointSum, getVipTime2 } from "../../models";

//checkbox的id数组

class VerifyResult extends Component{
  constructor(props){
    super(props)
    this.state = {
      userInfo: {},
    }
    this.orderId = getQueryString("orderId");
    this.batchId = this.props.match.params.batchId;
    this.getVerifyData = this.getVerifyData.bind(this);
    this.forGetPayResult = this.forGetPayResult.bind(this);
  }
  render(){
    const { verifyDataList=[],history } = this.props;
    const { userInfo=[] } = this.state;
    return (
      <div className="verifyResult-wrap">
        <div className="container">
          <div className="title">调查结果</div>
          <div className="user">
            <span><em>姓名：</em>{userInfo.realName}</span>
            <span><em>身份证号：</em>{userInfo.idNo}</span>
            <span><em>手机号：</em>{userInfo.phoneNo}</span>
          </div>
          <div className="content">
            {
              verifyDataList.map((item,index)=>{
                if(item.itemId >= 13 ) { return null }  ;
                return (
                  
                  ( item.usable && item.status===1 && <ResultShow  key={item.itemId} data={item} batchId={this.batchId}></ResultShow> ) ||
                  ( item.usable && item.status===2 && <ResultError key={item.itemId} data={item} batchId={this.batchId} getDataCallback={this.getVerifyData}></ResultError> ) ||
                  ( !item.usable && <ResultHide key={item.itemId} data={item} batchId={this.batchId} getDataCallback={this.getVerifyData}></ResultHide> ) ||
                  // ( item.usable &&  <ResultShow key={item.itemId} data={item} batchId={this.batchId}></ResultShow> ) 
                  ( item.usable && <ResultHide key={item.itemId} data={item} batchId={this.batchId} getDataCallback={this.getVerifyData}></ResultHide> ) 
                )
              })
            }
          </div>
        </div>
        <div style={{width:'1000px',margin:'20px auto',color:"#999",fontSize: '12px'}}>
            查询请注意<br/>

            1、您需在被核实人短信授权成功后查看背景核实服务核实结果。查询前请您与被核实人沟通一致，避免被核实人因超24h未操作短信授权、拒绝授权等导致被核实人授权失败。<br/>

            2、请确保您输入的被核实人姓名、手机号（本人身份证办理实名认证的）、身份证号码正确，避免因您输入错误导致被核实人授权失败。<br/>

            3、如因上述2种情况发生导致被核实人授权失败，不予退还您就当笔服务订单已支付的服务费用，但您享有当笔服务订单2次重试的机会。
        </div>
        <div className="ToPay">
          <ToPay batchId={this.batchId} getDataCallback={this.getVerifyData} ></ToPay>
        </div>
         <ModalPop history={history}></ModalPop>
      </div>
    )
  }
  componentDidMount(){
    // 初次进来的时候如果是充值回退，弹出弹框
    const { setLoadingState } = this.props;
    this.getVerifyData();
    if(this.orderId && this.orderId !== sessionStorage.getItem("orderId")){
      setLoadingState(true);  // 开启loading
      this.forGetPayResult(this.orderId);
      sessionStorage.setItem("orderId",this.orderId);
    }
  }
  // 支付成功轮询函数
  forGetPayResult(orderId){
    const { setPopData, setLoadingState } = this.props;
    getPayResult(orderId).then((res)=>{
      if(res.status==="PENDING"){
        let timer = setTimeout(() => {
          this.forGetPayResult(orderId)
          clearTimeout(timer);
        }, 500);
        return ;
      }
      console.log(res);
      let title = "";
      let textContent = "";
      switch (res.rechargeType) {
        case 4:
          title = "支付"
          textContent = `您已成功支付${res.orderMoney}元`
          break;
        case 1:
          title = "充值"
          textContent = `您已成功充值${res.addPoints}点`
          break;
        case 2:
          title = "充值并消耗"
          textContent = ``
          break;
      
        default:
          break;
      }
      let flag = res.status==="SUCCESS";
      let popData= {
        isShowModal: true,
        isPayModal: false,
        isSuccess: flag,
        data: {
          title: flag ? `${title}成功` : `${title}失败`,
          text: flag ? textContent : "请检查网络或重新支付",
          buttonText: flag ? "确定" : "关闭并重试"
        }
      }
      setLoadingState(false)  // 关闭loading
      setPopData(popData)
      this.getVerifyData(); // 重新请求数据
    }).catch(()=>{})
  }

  // 请求数据函数
  getVerifyData(){
    // console.log("重新请求数据的方法执行了");
    const { setVerifyresult } = this.props;
    Promise.all([ getVerifyResultData(this.batchId), getUserName(this.batchId), getPointSum(), getVipTime2() ]).then((resultArr)=>{
      let verifyDataList = resultArr[0];
      let userInfo = resultArr[1];
      let pointSum = resultArr[2];
      let vipInfo = resultArr[3];
      let plainOptions = [];
      let checkedList = [];
      let vipItems = [];
      this.setState({userInfo});
      verifyDataList.forEach((item)=>{
        if(!item.usable){
          plainOptions.push(item.itemId);
          if([1,2,3].indexOf(item.itemId) !== -1 && checkedList.indexOf(item.itemId) === -1 ){
            checkedList.push(item.itemId);
          }
          if(item.canUseVip && vipInfo.amount>0){
            vipItems.push(item.itemId);
          }
        }
      })
      // console.log(verifyDataList);
      setVerifyresult({ plainOptions, checkedList, verifyDataList, vipItems, pointSum, vipInfo });
    }).catch(()=>{})
  }
}

const mapState = (store)=>{
  return {
    verifyDataList: store.verifyResult.verifyDataList,
    vipInfo: store.verifyResult.vipInfo,
  }
}
const mapDispatch = (dispatch)=>{
  return {
    setVerifyresult(data){
      dispatch({
        type: "setVerifyresult",
        data,
      })
    },
    setPopData(data){
      dispatch({
        type: "setPopData",
        data,
      })
    },
    setLoadingState(data){
      dispatch({
        type: "setLoadingState",
        data
      })
    }
  }
}
export default connect(mapState,mapDispatch)(VerifyResult);
